import { gql } from "../generated";

export const COUNTIES = gql(`
  query Counties($zipCode: String!) {
    counties(zipCode: $zipCode) {
      fips
      name
      state
      zipcode
    }
  }
`);